/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SplitBillOfMaterialData } from '../../models/split-bill-of-material-data';

export interface SplitBillOfMaterialData$Params {
  productionOrderId: number;
  billOfMaterialId: number;
}

export function splitBillOfMaterialData(http: HttpClient, rootUrl: string, params: SplitBillOfMaterialData$Params, context?: HttpContext): Observable<StrictHttpResponse<SplitBillOfMaterialData>> {
  const rb = new RequestBuilder(rootUrl, splitBillOfMaterialData.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.path('billOfMaterialId', params.billOfMaterialId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SplitBillOfMaterialData>;
    })
  );
}

splitBillOfMaterialData.PATH = '/api/v1/ProductionOrder/{productionOrderId}/billOfMaterials/{billOfMaterialId}/SplitBillOfMaterialData';
